import { Modifiers } from '@daypicker/react'
import { astraTwMerge } from 'astra'

type DayModifier = 'today' | 'selected' | 'range_start' | 'range_middle' | 'range_end' | 'hoverRange' | 'hoverRangeStart' | 'hoverRangeEnd'

type DayState = {
    today: boolean
    selected: boolean
    rangeStart: boolean
    rangeMiddle: boolean
    rangeEnd: boolean
    hoverRangeStart: boolean
    hoverRangeEnd: boolean
    singleDayRange: boolean
    hoverRangeMiddle: boolean
    hoverRangeSingleDay: boolean
    hoveringSelectedRangeStart: boolean
    hoveringSelectedRangeEnd: boolean
}

const brandRangeStart = "bg-[linear-gradient(to_right,transparent_50%,theme('backgroundColor.brand-subtle-rest')_50%)]"
const brandRangeEnd = "bg-[linear-gradient(to_right,theme('backgroundColor.brand-subtle-rest')_50%,transparent_50%)]"
const hoverRangeStart = "bg-[linear-gradient(to_right,transparent_50%,theme('backgroundColor.surface-strong')_50%)]"
const hoverRangeEnd = "bg-[linear-gradient(to_right,theme('backgroundColor.surface-strong')_50%,transparent_50%)]"
const hoverFromSelectedEnd = "bg-[linear-gradient(to_right,theme('backgroundColor.brand-subtle-rest')_50%,theme('backgroundColor.surface-strong')_50%)]"
const hoverFromSelectedStart = "bg-[linear-gradient(to_right,theme('backgroundColor.surface-strong')_50%,theme('backgroundColor.brand-subtle-rest')_50%)]"

const hasModifier = (modifiers: Modifiers, modifier: DayModifier) => Boolean(modifiers[modifier])

function getDayState(modifiers: Modifiers): DayState {
    const rangeStart = hasModifier(modifiers, 'range_start')
    const rangeEnd = hasModifier(modifiers, 'range_end')
    const hoverRangeStartModifier = hasModifier(modifiers, 'hoverRangeStart')
    const hoverRangeEndModifier = hasModifier(modifiers, 'hoverRangeEnd')
    const selected = hasModifier(modifiers, 'selected')

    return {
        today: hasModifier(modifiers, 'today'),
        selected,
        rangeStart,
        rangeMiddle: hasModifier(modifiers, 'range_middle'),
        rangeEnd,
        hoverRangeStart: hoverRangeStartModifier,
        hoverRangeEnd: hoverRangeEndModifier,
        singleDayRange: rangeStart && rangeEnd,
        hoverRangeMiddle: hasModifier(modifiers, 'hoverRange') && !hoverRangeStartModifier && !hoverRangeEndModifier,
        hoverRangeSingleDay: hoverRangeStartModifier && hoverRangeEndModifier,
        hoveringSelectedRangeStart: selected && rangeStart && !rangeEnd && hoverRangeEndModifier,
        hoveringSelectedRangeEnd: selected && rangeEnd && !rangeStart && hoverRangeStartModifier,
    }
}

export function getDayCellStyles(modifiers: Modifiers): string {
    const state = getDayState(modifiers)

    return astraTwMerge(
        state.rangeStart && !state.singleDayRange ? brandRangeStart : '',
        state.rangeMiddle ? 'bg-brand-subtle-rest hover:bg-brand-subtle-hover' : '',
        state.rangeEnd && !state.singleDayRange ? brandRangeEnd : '',
        state.hoverRangeMiddle ? 'bg-surface-strong text-default' : '',
        state.hoverRangeStart && !state.hoverRangeSingleDay ? hoverRangeStart : '',
        state.hoverRangeEnd && !state.hoverRangeSingleDay ? hoverRangeEnd : '',
        state.hoveringSelectedRangeEnd ? hoverFromSelectedEnd : '',
        state.hoveringSelectedRangeStart ? hoverFromSelectedStart : ''
    )
}

export function getDayButtonStyles(modifiers: Modifiers): string {
    const state = getDayState(modifiers)

    return astraTwMerge(
        state.today ? 'rounded-full border border-base' : '',
        state.selected ? 'rounded-full bg-brand-strong-rest text-white hover:bg-brand-strong-hover' : '',
        state.rangeMiddle || state.hoverRangeMiddle || state.hoveringSelectedRangeStart || state.hoveringSelectedRangeEnd
            ? 'rounded-none border-none bg-transparent text-default hover:!bg-transparent'
            : '',
        (state.hoverRangeStart || state.hoverRangeEnd) && !state.selected ? 'bg-surface-strong' : ''
    )
}
